export class Grid_Therapist_ExtModel {
    public therapistID?: number = 0;
    public systemUserID?: number = 0;
    public email?: string = "";
    public firstName?: string = "";
    public lastName?: string = "";
    public profileLarge?: string | null = null;
    public profileSmall?: string | null = null;
    public profileLargeURL?: string | null = null;
    public profileSmallURL?: string | null = null;
    public therapistStatusID?: number = 0;
    public startTime?: string | null = null;
    public endTime?: string | null = null;
    public acceptBookings?: boolean = true;
    public working?: boolean = true;
    public active?: boolean = true;
    public therapistStatusName?: string | null = null;
    public bookingsWaiting?: number = 0;
    public availability?: string = "";
    public activeDates?: string[] = [];
}
